import * as React from 'react';

interface Props {}

export const BrannanSVG: React.SFC<Props> = ({}) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" />
      <rect x="12.5" y="2.5" width="39" height="59" stroke="#333333" />
      <line x1="24" y1="7.5" x2="40" y2="7.5" stroke="black" />
      <rect x="16.5" y="11.5" width="31" height="21" stroke="#333333" />
      <rect x="25" y="42" width="14" height="1" fill="#333333" />
      <rect x="27" y="39" width="10" height="1" fill="#333333" />
    </svg>
  );
};
